<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="true"
        :is-full-page="true"
    ></b-loading>
    <b-collapse
        class="card shadow"
        animation="slide"
        v-model="isOpen"
        style="border-radius: 16px; background-color: #f9f9f9;"
        aria-id="contentIdForA11y3">
      <template #trigger>
        <div
            class="card-header shadow"
            role="button"
            aria-controls="contentIdForA11y3"
            style="border-radius: 16px; background-color: white; height: 72px;">
          <div class="card-header-title pl-5">
            <div class="columns" style="width: 100%">
              <div class="column" style="min-width: 350px">
                <div class="is-size-7 has-text-grey-light has-text-weight-normal">Site name</div>
                <div class="has-text-black">{{site.siteName}}</div>
              </div>
              <div class="column">
                <div class="is-size-7 has-text-grey-light has-text-weight-normal">Client Site Code</div>
                <div class="has-text-black">{{site.clientSiteCodes ? site.clientSiteCodes.toString() : ''}}</div>
              </div>
              <div class="column mr-0 pr-0">
                <div class="is-size-7 has-text-grey-light has-text-weight-normal">Status</div>
                <div class="is-flex is-flex-direction-row is-align-items-center">
                  <div class="count-indicator has-text-white is-size-7 has-background-danger">New ({{getNew()}})</div>
                  <div class="count-indicator has-text-white ml-3 has-background-grey is-size-7">Responded ({{getResponded()}})</div>
                  <div class="count-indicator has-text-white ml-3 has-background-primary  is-size-7">Submitted ({{getSubmitted()}})</div>
                </div>
              </div>
              <div class="column is-flex ml-3" style="width: 120px; max-width: 120px;">
                <b-button icon-left="send" type="is-primary" class="ml-auto mt-2" size="is-small" :disabled="!changed" @click.stop="onUpdateDtpQueries">
                  Respond
                </b-button>
              </div>
            </div>
          </div>

          <a class="card-header-icon">
            <b-icon
                :icon="isOpen ? 'chevron-down' : 'chevron-up'">
            </b-icon>
          </a>
        </div>
      </template>

      <div class="card-content">
        <div class="content">
          <dtp-single-query v-for="query in site.queries" :key="query._id + query.rttResponseStatus" :query="query" class="mb-3" @onResponseChanged="onResponseChanged"></dtp-single-query>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

import DtpSingleQuery from "@/modules/dtp-query/components/dtp-single-query/dtp-single-query.vue";

export default {
  name: "dtp-query-site-card",
  components: {DtpSingleQuery},
  props: {
    site: {
      type: Object
    }
  },
  data() {
    return {
      isOpen: false,
      isLoading: false,
      isSelected: false,
      responses: {},
      changed: false,
    }
  },
  methods: {
    ...mapActions({
      updateDtpQueries: 'dtpQueryModule/updateDtpQueries',
    }),
    async onUpdateDtpQueries() {
      const payload = Object.entries(this.responses).map(([id, response]) => ({
        _id: id,
        rttResponse: response
      }));
      console.log('Payload: ', payload)
      this.isLoading = true;
      const response = await this.updateDtpQueries(payload)
      console.log('Response: ', response)
      if (response instanceof Error) {
        this.showToast(`Error: ${response.message}`, 'is-danger')
      }else{
        if(response && response.lambdaResponse && response.lambdaResponse.status === 'OK'){
          this.showToast(response.lambdaResponse.message, 'is-success')
        }else if(response && response.lambdaResponse && response.lambdaResponse.errorMessage){
          this.showToast(response.lambdaResponse.errorMessage, 'is-danger')
        }
        this.responses = {}
      }
      this.isLoading = false
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    },
    getNew(){
      if(this.site && this.site.queries && this.site.queries.length > 0){
        return this.site.queries.filter(q => q.rttResponseStatus === 'new').length
      }

      return '-'
    },
    getResponded(){
      if(this.site && this.site.queries && this.site.queries.length > 0){
        return this.site.queries.filter(q => q.rttResponseStatus === 'responded').length
      }
      return '-'
    },
    getSubmitted(){
      if(this.site && this.site.queries && this.site.queries.length > 0){
        return this.site.queries.filter(q => q.rttResponseStatus === 'submitted').length
      }
      return '-'
    },
    onResponseChanged(data){
      if(this.site && this.site.queries && this.site.queries.length > 0){
        const index = this.site.queries.findIndex(query => query._id === data._id)
        if(index !== -1){
          if(this.site.queries[index].rttResponse !== data.response && data.response !== null){
            this.responses[data._id] = data.response
          }else{
            delete this.responses[data._id]
          }
        }
      }
      this.changed = this.responses && Object.keys(this.responses).length > 0;
      console.log('Responses: ', this.responses)
    },

  },
  computed: {
    ...mapGetters({
    }),
  },
}
</script>

<style lang="scss" scoped>
.shadow {
  box-shadow: 0 0.125em 0.125em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%)
}

.count-indicator {
  border-radius: 4px;
  padding: 3px 12px;
  background: black;
  font-size: 12px;
}

.card-header-title {
  align-items: center;
  color: hsl(0deg, 0%, 21%);
  flex-grow: 1;
  font-weight: 700;
  padding: 0;
}
</style>